import React from 'react'

export type DragHandleIconProps = {
  size?: number
  color?: string
  className?: string
}

// Six-dot drag handle for reorderable list rows. No Figma spec yet (map/list
// GAP component) — token-derived minimal glyph, pending async design
// sign-off. Defaults to currentColor so it inherits the surrounding color.
export const DragHandleIcon = ({
  size = 20,
  color = 'currentColor',
  className,
}: DragHandleIconProps) => (
  <svg
    aria-label='Drag handle'
    className={className}
    fill='none'
    height={size}
    role='img'
    viewBox='0 0 20 20'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    {[5, 10, 15].map((y) =>
      [7, 13].map((x) => (
        <circle cx={x} cy={y} fill={color} key={`${x}-${y}`} r={1.5} />
      ))
    )}
  </svg>
)
